import React from "react";

const Bounce = () => {
	return (
		<div className="size-10" data-testid="py-component-loader">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="100%"
				height="100%"
				viewBox="0 0 92 120"
				fill="none"
				preserveAspectRatio="xMidYMax meet"
				style={{ color: "var(--py-primary-6)" }}
			>
				<g transform="translate(0,18)">
					{/* Right tall bar - rounded top, flat bottom */}
					<path d={"M 68 54.5 Q 68 43 79.5 43 H 79.5 Q 91 43 91 54.5 V 97 H 68 Z"} fill="currentColor"></path>

					{/* Middle bar - rounded top, flat bottom */}
					<path
						d={"M 34.5 76 Q 34.5 64.5 46 64.5 H 46 Q 57.5 64.5 57.5 76 V 99 H 34.5 Z"}
						fill="currentColor"
					/>

					{/* Left short bar - rounded top, flat bottom */}
					<path
						d={"M 0.1 99.5 Q 0.1 88 11.6 88 H 11.6 Q 23.1 88 23.1 99.5 V 102 H 0.1 Z"}
						fill="currentColor"
					/>

					{/* Bottom-left circle */}
					<circle cx="11.7" cy="71.2" r="11.6" fill="currentColor">
						<animate
							attributeName="cy"
							values="71.2; 54; 71.2"
							dur="1.2s"
							repeatCount="indefinite"
							calcMode="spline"
							keyTimes="0; 0.5; 1"
							keySplines="0.25,0.46,0.45,0.94; 0.55,0.06,0.68,0.19"
						/>
					</circle>

					{/* Middle circle */}
					<circle cx="46.1" cy="48.2" r="11.6" fill="currentColor">
						<animate
							attributeName="cy"
							values="48.2; 34; 48.2"
							dur="1.2s"
							begin="0.15s"
							repeatCount="indefinite"
							calcMode="spline"
							keyTimes="0; 0.5; 1"
							keySplines="0.25,0.46,0.45,0.94; 0.55,0.06,0.68,0.19"
						/>
					</circle>

					{/* Top-right circle */}
					<circle cx="79.5" cy="26.1" r="11.6" fill="currentColor">
						<animate
							attributeName="cy"
							values="26.1; 14; 26.1"
							dur="1.2s"
							begin="0.3s"
							repeatCount="indefinite"
							calcMode="spline"
							keyTimes="0; 0.5; 1"
							keySplines="0.25,0.46,0.45,0.94; 0.55,0.06,0.68,0.19"
						/>
					</circle>
				</g>
			</svg>
		</div>
	);
};

export default Bounce;
